<template>
  <div class="min-height-100">
    <template v-if="isMobile">
      <mobile-filter-header :show-filters="() => setMobileFilterVisibility(true)" />
      <mobile-filter-panel
        :total-count="pagination.totalCount"
        :show="showMobileFilter"
        :hide-filters="() => setMobileFilterVisibility(false)"
        :filter-panel-config="getFilterPanelConfig()"
      />
    </template>
    <div class="search-result-page">
      <filter-panel
        v-if="!isMobile"
        :total-count="pagination.totalCount"
        :filter-panel-config="getFilterPanelConfig()"
      ></filter-panel>
      <div class="page-content">
        <div class="page-header">
          <div v-if="categoryInfo && !categoryInfo.isParent" class="back-to-parent" @click="backToParent()">
            <inline-svg class="clear-icon" :src="require('@/assets/img/icons/chevron_left.svg')"></inline-svg>
            <h4 class="parent-category">
              {{ categoryInfo.parentCategoryName }}
            </h4>
          </div>
          <div class="page-title-row">
            <div class="page-title">{{ getPageTitle() }}</div>
            <sorting-options v-if="!isMobile" />
          </div>
          <h4 v-if="isMobile && pagination.totalCount" class="mobile-total-count color-gray">
            {{ pagination.totalCount }} TOTAL RESULTS
          </h4>
          <filter-badges class="filter-badges" />
        </div>
        <product-tiles :loading="loading" :products="products" :pagination="pagination" :set-page="setPage" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped src="../../assets/sass/searchPage/searchPage.scss"></style>

<script>
import { searchPageMobileStateHelper } from "../../components/mixin/search/searchPageMobileStateHelper";
import { FilterKeys, RouterPath } from "../../services/utils";
import InlineSvg from "vue-inline-svg";
import { algoliaProductHelper } from "../../components/mixin/search/algoliaProductHelper";

export default {
  components: {
    InlineSvg,
  },
  mixins: [algoliaProductHelper, searchPageMobileStateHelper],
  data() {
    return {
      filterOrSortUsed: false,
      filtersOrSortsUsed: new Set(),
      products: [],
      favoriteList: [],
      categoryInfo: null,
      defaultSorting: "created_at_asc",
    };
  },
  watch: {
    "$route.query": function (query) {
      this.initCategoryInfo();
      this.getProductsOnSearch(query, { pageLevelCategoryFilter: this.categoryInfo });
    },
  },
  async beforeMount() {
    const redirect = this.redirectToCollectionPageFromLegacyRoute();
    if (redirect) {
      return;
    }
    await this.getCategories();
    this.initCategoryInfo();
    await this.getFavouriteProducts();

    if (!this.$route.query.sortBy) {
      this.updateURLParams("page", 1);
      this.updateURLParams("sortBy", this.defaultSorting);
    } else {
      this.getProductsOnSearch(this.$route.query, { pageLevelCategoryFilter: this.categoryInfo });
    }
  },
  methods: {
    getCategories,
    initCategoryInfo,
    getPageTitle,
    getFilterPanelConfig,
    findParentCategory,
    findSubCategory,
    backToParent,
    redirectToCollectionPageFromLegacyRoute,
  },
};

// Supporting legacy routes and redirect if its necessary
// example: collections/Gifts%20for%20the%20Foodie/d6bf032e-7164-497c-a875-12fd21901fef/products
function redirectToCollectionPageFromLegacyRoute() {
  const { navItemParentName, navItemName, navItemId } = this.$route.params;
  if (navItemParentName === "collections") {
    this.$router.replace({ path: `/collection/${navItemName}/${navItemId}`, query: this.$route.query });
    return true;
  }
}

async function getCategories() {
  this.categories = await this.$utils.getProductCategories(true);
}

function getFilterPanelConfig() {
  const { isParent, parentCategoryId } = this.categoryInfo || {};

  return {
    hiddenFilters: !isParent ? [FilterKeys.CATEGORIES.toString()] : [],
    filterSettings: {
      [FilterKeys.CATEGORIES]: {
        parentCategoryId: parentCategoryId,
        categories: this.categories,
      },
    },
  };
}

function initCategoryInfo() {
  const { navItemParentName, navItemName, navItemId } = this.$route.params;

  function capitalize(word) {
    return word && word?.length ? word[0].toUpperCase() + word.slice(1).toLowerCase() : "";
  }

  const isParent = !navItemParentName;
  this.categoryInfo = {
    isParent,
    parentCategoryId: isParent ? navItemId : null,
    parentCategoryName: this.findParentCategory()?.name,
    subCategoryName: !isParent ? this.findSubCategory(navItemId)?.info?.text : "",
    value: isParent ? capitalize(navItemName) : navItemId,
  };
}

function findParentCategory() {
  const { navItemParentName, navItemId } = this.$route.params;

  if (!navItemParentName) {
    return this.categories.find((item) => item.id === navItemId);
  } else {
    return this.categories.find((parent) => {
      return parent.view_components?.find((item) => item.entity_id === navItemId);
    });
  }
}

function findSubCategory(id) {
  let subCategory = null;
  this.categories.find((parent) => {
    const found = parent.view_components?.find((item) => item.entity_id === id);
    if (found) {
      subCategory = found;
    }
  });
  return subCategory;
}

function backToParent() {
  const category = this.findParentCategory();
  this.$router.push(`/${category.name}/${category.id}/${RouterPath.CATEGORY_PRODUCTS_PAGE}`);
}

function getPageTitle() {
  const { isParent, parentCategoryName, subCategoryName } = this.categoryInfo || {};
  return isParent ? parentCategoryName : subCategoryName;
}
</script>
